const CreditOrDebitPosTransactionTypes: any = {
  POS_CC: {
    description: 'All POS and Credit Card transactions',
    value: 'POS_CC',
  },
  POS_PIN_CC: {
    description: 'POS PIN and Credit Card transactions',
    value: 'POS_PIN_CC',
  },
  POS_SIGNATURE_CC: {
    description: 'POS Signature and Credit Card transactions',
    value: 'POS_SIGNATURE_CC',
  },
};

export default CreditOrDebitPosTransactionTypes;
